import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input, model } from "@angular/core";
import { StrategyDspAudiencePreset } from "@front/m19-api-client";
import { IIconComponent, ILabelComponent, IRadioComponent, IRadioGroupComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-dsp-audience-preset-selector",
  imports: [TranslocoDirective, NgClass, IIconComponent, IRadioComponent, IRadioGroupComponent, ILabelComponent],
  template: `<IRadioGroup
    class="flex gap-4"
    *transloco="let t"
    name="manualOrSmartAudiencePreset"
    [value]="isManualAudiencePreset()"
    (valueChange)="select($event)"
  >
    <label iLabel class="flex w-64 cursor-pointer items-center justify-between" for="manual" type="card">
      <div class="flex flex-row items-center gap-4">
        <IIcon
          name="target"
          class="text-2xl"
          [ngClass]="isManualAudiencePreset() === true ? 'text-main' : 'text-muted-foreground'"
        />
        <div>
          <div class="type-body-medium">{{ t("dsp-audience-preset.manual_preset_title") }}</div>
          <div class="text-muted-foreground">{{ t("dsp-audience-preset.manual_preset_description") }}</div>
        </div>
      </div>
      <IRadio id="manual" [value]="true" size="lg" />
    </label>
    <label iLabel class="flex w-64 cursor-pointer items-center justify-between" for="smart" type="card">
      <div class="flex flex-row items-center gap-4">
        <IIcon
          name="star"
          class="text-xl"
          [ngClass]="isManualAudiencePreset() === false ? 'text-main' : 'text-muted-foreground'"
        />
        <div>
          <div class="type-body-medium">{{ t("dsp-audience-preset.smart_audience_preset_title") }}</div>
          <div class="text-muted-foreground">{{ t("dsp-audience-preset.smart_audience_preset_description") }}</div>
        </div>
      </div>
      <IRadio id="smart" [value]="false" size="lg" />
    </label>
  </IRadioGroup>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspAudiencePresetSelectorComponent {
  private readonly DEFAULT_SMART_AUDIENCE_PRESET = StrategyDspAudiencePreset.RETARGETING;

  readonly audiencePreset = model.required<StrategyDspAudiencePreset>();
  readonly currentSmartAudiencePreset = input<StrategyDspAudiencePreset>(this.DEFAULT_SMART_AUDIENCE_PRESET);

  readonly isManualAudiencePreset = computed(() => this.audiencePreset() === StrategyDspAudiencePreset.MANUAL);

  select(manualAudience?: boolean) {
    if (manualAudience === undefined) {
      return;
    }
    if (manualAudience) {
      this.audiencePreset.set(StrategyDspAudiencePreset.MANUAL);
      return;
    }
    const smartAudienceToSelect =
      this.currentSmartAudiencePreset() !== StrategyDspAudiencePreset.MANUAL
        ? this.currentSmartAudiencePreset()
        : this.DEFAULT_SMART_AUDIENCE_PRESET;
    this.audiencePreset.set(smartAudienceToSelect);
  }
}
